import { render, staticRenderFns } from "./index.vue?vue&type=template&id=042c44d8"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/frontend_coduck_manage_sbGx/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('042c44d8')) {
      api.createRecord('042c44d8', component.options)
    } else {
      api.reload('042c44d8', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=042c44d8", function () {
      api.rerender('042c44d8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/layout/components/PageMain/index.vue"
export default component.exports